import { staticAssetUrl } from '@/utils/staticAssets'
import styles from './AuthShell.module.css'

function BrandLockup({ compact = false }) {
  return (
    <div className={compact ? styles.mobileBrandLockup : styles.brandLockup}>
      <img
        className={compact ? styles.mobileLogoMark : styles.logoMark}
        src={staticAssetUrl('site-static/logo-coin.png')}
        alt=""
      />
      <span className={styles.brandName}>
        <strong>Wager</strong>
        <span>Studio</span>
      </span>
    </div>
  )
}

export function AuthShell({ children }) {
  return (
    <main className={styles.splitLayout}>
      <section className={styles.brandPanel} aria-labelledby="studio-auth-brand-message">
        <BrandLockup />

        <div className={styles.brandMessage}>
          <p className={styles.eyebrow}>Multi-product workspace</p>
          <p className={styles.brandDisplay} id="studio-auth-brand-message">
            Manage every Wager product in one place.
          </p>
          <p className={styles.brandDescription}>
            Keep your organization, products, and operations connected in one workspace.
          </p>
        </div>

        <p className={styles.desktopSupport}>Need access? Contact the team.</p>
      </section>

      <section className={styles.formPanel} aria-label="Studio account access">
        <div className={styles.mobileBrand}>
          <BrandLockup compact />
        </div>
        <div className={styles.formContainer}>{children}</div>
        <p className={styles.mobileSupport}>Need access? Contact the team.</p>
      </section>
    </main>
  )
}
